import { createBrowserHistory, createMemoryHistory } from 'history';

// createBrowserHistory() requires a real window/DOM (it accesses window.location).
// When this module is loaded by the SSR bundle running in Node.js there is no window,
// so we fall back to an in-memory history that does nothing at runtime but prevents
// the import from crashing.
const isBrowser = typeof window !== 'undefined';
const history = isBrowser ? createBrowserHistory() : createMemoryHistory();

const allowResetScrollOnPage = ['query-library'];

// cache the current page
let previousLocation = {
    pathname: '',
    search: ''
};

function resetScroll() {
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
}

history.listen(location => {
    const hasPageChanged = (previousLocation.pathname && previousLocation.pathname !== location.pathname) || location.search.length === 0;
    const resetScrollOnPage = location.search.length > 0 && allowResetScrollOnPage.filter(page => location.pathname.indexOf(page) > -1).length > 0;
    const hasHash = location.hash !== '';

    if ((hasPageChanged && !hasHash) || resetScrollOnPage) setTimeout(resetScroll, 1);

    // update cached page
    previousLocation = location;
});

export default history;
